import { render, staticRenderFns } from "./imeiPhoto.vue?vue&type=template&id=23b6fde4&scoped=true"
import script from "./imeiPhoto.vue?vue&type=script&lang=js"
export * from "./imeiPhoto.vue?vue&type=script&lang=js"
import style0 from "./imeiPhoto.vue?vue&type=style&index=0&id=23b6fde4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b6fde4",
  null
  
)

export default component.exports